import { useSelector } from 'react-redux';

const useDatasetNotificationCreateDialog = () => {
  const {
    createErrors, createStatus, datasetName, update: { name, description },
  } = useSelector(
    ({ datasetNotifications: { datasetNotification } }) => datasetNotification,
  );
  return {
    createErrors,
    createStatus,
    datasetName,
    description,
    name,
  };
};

export default {
  useDatasetNotificationCreateDialog,
};
